import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { supabase } from '../services/supabase';

export default function HealthConsentGate({ children }) {
  const { user } = useAuth();
  const [checking, setChecking] = useState(true);
  const [consented, setConsented] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!user?.uid) { setChecking(false); return; }
    supabase.from('profiles').select('salud_consent_at').eq('id', user.uid).single()
      .then(({ data }) => {
        setConsented(!!data?.salud_consent_at);
        setChecking(false);
      });
  }, [user?.uid]);

  const aceptar = async () => {
    setSaving(true);
    await supabase.from('profiles').update({ salud_consent_at: new Date().toISOString() }).eq('id', user.uid);
    setConsented(true);
    setSaving(false);
  };

  if (checking) return null;
  if (consented) return children;

  return (
    <div style={{
      minHeight: 'calc(100vh - 64px)', background: 'var(--bg)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
    }}>
      <div style={{
        background: 'var(--navy-card)', border: '1px solid var(--navy-border)',
        borderRadius: 18, padding: 24, maxWidth: 360, textAlign: 'center',
      }}>
        <div style={{ fontSize: 32, marginBottom: 14 }}>💙</div>
        <p style={{ color: 'var(--white)', fontSize: 14, lineHeight: 1.6, marginBottom: 18 }}>
          Este espacio es para orientarte, no para reemplazar a tu médico. Cuéntale lo que necesites — tu consulta la responde un asistente de IA, pensado para darte claridad rápido y en español.
        </p>
        <button
          onClick={aceptar}
          disabled={saving}
          className="btn-primary"
          style={{ width: '100%', opacity: saving ? 0.6 : 1 }}
        >
          Entendido, continuar
        </button>
      </div>
    </div>
  );
}
